export const isIntercomEnabled = (state) => state.settings.intercomEnabled;
export const isIntercomEnabledLoggedInPages = (state) => state.settings.intercomEnabledLoggedInPages;
export const getIntercomAppId = (state) => state.settings.intercomAppId;
export const getIntercomUserHash = (state) => state.settings.intercomUserHash;
